__turbopack_context__.v({
  "body": "Callout-module-scss-module__YBLlpa__body",
  "callout": "Callout-module-scss-module__YBLlpa__callout",
  "header": "Callout-module-scss-module__YBLlpa__header",
  "intent-accent": "Callout-module-scss-module__YBLlpa__intent-accent",
  "intent-error": "Callout-module-scss-module__YBLlpa__intent-error",
  "intent-primary": "Callout-module-scss-module__YBLlpa__intent-primary",
  "intent-success": "Callout-module-scss-module__YBLlpa__intent-success",
  "intent-warning": "Callout-module-scss-module__YBLlpa__intent-warning",
  "title": "Callout-module-scss-module__YBLlpa__title",
});
